import privacySource from '../../content/legal/privacy.md?raw';
import { LegalLayout } from './LegalLayout';

export default function Privacy() {
  return <LegalLayout source={privacySource} />;
}
